import { Auth } from "@/helpers/Auth";
import { BaseSocket } from "@/store/modules/sockets/baseSocket";
import { checkEndUrlConfig } from "@/helpers/checkEndUrlConfig";
export class StatusIndicationSocket extends BaseSocket {
    constructor() {
        super(...arguments);
        this.apiUrl = `${checkEndUrlConfig(Auth.getWebGatewayUriForSocket)}ApplicationStateService?accessToken=${Auth.getToken}`;
    }
}
